import { Select, MenuItem, FormControl, InputLabel, Box, Chip } from '@mui/material'
import { useInstance } from '../contexts/InstanceContext'

export function InstanceSelector() {
  const { currentInstance, instances, switchInstance, loading } = useInstance()

  if (loading || !currentInstance || instances.length === 0) {
    return null
  }

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active':
        return 'success'
      case 'provisioning':
        return 'warning'
      case 'failed':
        return 'error'
      default:
        return 'default'
    }
  }

  return (
    <FormControl size="small" sx={{ minWidth: 250, mr: 2 }}>
      <InputLabel>Instance</InputLabel>
      <Select
        value={currentInstance.id}
        label="Instance"
        onChange={(e) => switchInstance(e.target.value)}
      >
        {instances.map((instance) => (
          <MenuItem key={instance.id} value={instance.id}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
              <Box sx={{ flexGrow: 1 }}>
                {instance.name}
              </Box>
              <Chip
                label={instance.status}
                size="small"
                color={getStatusColor(instance.status) as any}
              />
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

